import { Injectable } from '@angular/core';
import {
  Firestore,
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where
} from '@angular/fire/firestore';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private readonly firestore: Firestore) { }

  async getSettingsData(id: string) {
    const settingsCollection = collection(this.firestore, 'settings');
    const q = query(settingsCollection, where('backofficeAdminDocIds', 'array-contains', id));
    return getDocs(q);
  }

  create(uid: string): Promise<void> {
    const settingsDoc = doc(this.firestore, 'settings', 'backoffice');
    return updateDoc(settingsDoc, { 
      backofficeAdminDocIds: arrayUnion(uid) 
    });
  }

  delete(uid: string): Promise<void> {
    const settingsDoc = doc(this.firestore, 'settings', 'backoffice');
    return updateDoc(settingsDoc, {
      backofficeAdminDocIds: arrayRemove(uid)
    });
  }

  async isIdInClubRestrictedFeatures(id: string | string[]) {
    const docRef = doc(this.firestore, 'settings', 'clubRestrictedFeatures');

    try {
      const docSnapshot = await getDoc(docRef);

      if (!docSnapshot.exists()) {
        return false;
      }

      const data = docSnapshot.data() as { 'NEW_STREAM_CREATION_V2': string[] };
      const arrayField = data.NEW_STREAM_CREATION_V2 || [];
      
      if (Array.isArray(id)) {
        return id.map(clubId => arrayField.includes(clubId));
      } else {
        return Array.isArray(arrayField) && arrayField.includes(id);
      }

    } catch (error) {
      console.error('Error fetching document:', error);
      return false;
    }
  }

  async updateOTTStreamId(id: string) {
    const docRef = doc(this.firestore, 'settings', 'clubRestrictedFeatures');
    return updateDoc(docRef, {
      NEW_STREAM_CREATION_V2: arrayUnion(id)
    });
  }

  async removeOTTStreamId(id: string) {
    const docRef = doc(this.firestore, 'settings', 'clubRestrictedFeatures');
    return updateDoc(docRef, {
      NEW_STREAM_CREATION_V2: arrayRemove(id)
    });
  }
}
